import { typedAction } from '@gsc/preact-redux'
import type { RootState } from './store'
import type { GlobalSettings } from '../types'

export type GlobalSettingsState = GlobalSettings

const initialState: GlobalSettingsState = {
  logoUrl: null,
}

export function updateGlobalSettings(settings: Partial<GlobalSettings>) {
  return typedAction('globalSettings/UPDATE', settings)
}

type GlobalSettingsAction = ReturnType<typeof updateGlobalSettings>

export default function reducer(state = initialState, action: GlobalSettingsAction): GlobalSettingsState {
  switch (action.type) {
    case 'globalSettings/UPDATE':
      return { ...state, ...action.payload }
    default:
      return state
  }
}

// selectors
export function selectGlobalSettings(state: RootState): GlobalSettingsState {
  return state.globalSettings
}
